import React from 'react';
import TimeBridgeChart from '../TimeBridgeChart';
import './SavoirSections.css';

/* Rendu des sections d'une fiche Savoirs, selon leur type (data/savoirs.js).
   Venu de l'ancienne page Savoirs (2026-09-16) : la fiche se lit désormais
   dans le volet, le rendu ne change pas de gabarit. */
export function Section({ s, onNavigate, tenantId, year }) {
  return (
    <section className="sv-section">
      <h3 className={`sv-section-label sv-label-${s.kind}`}>{s.label}</h3>

      {s.kind === 'law' && (
        <>
          {s.articles.map((a, i) => (
            <blockquote key={i} className="sv-law">
              <div className="sv-law-ref">{a.ref}</div>
              <p className="sv-law-text">{a.text}</p>
            </blockquote>
          ))}
          {s.source && <p className="sv-source-note">{s.source}</p>}
        </>
      )}

      {(s.kind === 'text' || s.kind === 'palestre' || s.kind === 'illustration') && (
        <>
          {(s.paragraphs || []).map((p, i) => (
            <p key={i} className="sv-para">{p}</p>
          ))}
        </>
      )}

      {s.kind === 'illustration' && s.table && (
        <div className="sv-table-wrap">
          <table className="sv-table">
            <thead>
              <tr>{s.table.head.map((h, i) => <th key={i}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {s.table.rows.map((r, i) => (
                <tr key={i}>{r.map((c, j) => <td key={j}>{c}</td>)}</tr>
              ))}
            </tbody>
          </table>
          {s.table.note && <p className="sv-table-note">{s.table.note}</p>}
        </div>
      )}

      {s.kind === 'palestre' && s.link && (
        <button
          type="button"
          className="sv-link-btn"
          onClick={() => onNavigate && onNavigate(s.link.pageKey)}
        >
          {s.link.label} →
        </button>
      )}

      {s.kind === 'chart' && s.chart === 'time-bridge' && (
        <TimeBridgeChart tenantId={tenantId} year={year} />
      )}

      {s.kind === 'sources' && (
        <ul className="sv-sources">
          {s.items.map((it, i) => <li key={i}>{it}</li>)}
        </ul>
      )}
    </section>
  );
}

/** Normalise pour une recherche insensible à la casse et aux accents. */
export function normalize(str) {
  return String(str || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '');
}

/** Texte plein d'une fiche (pour la recherche). */
export function notionText(n) {
  const parts = [n.title, n.category, n.summary];
  (n.sections || []).forEach(s => {
    if (s.label) parts.push(s.label);
    if (s.paragraphs) parts.push(...s.paragraphs);
    if (s.articles) s.articles.forEach(a => parts.push(a.ref, a.text));
    if (s.source) parts.push(s.source);
    if (s.items) parts.push(...s.items);
    if (s.legend) parts.push(...s.legend);
    if (s.table) {
      parts.push(...s.table.head);
      s.table.rows.forEach(r => parts.push(...r));
      if (s.table.note) parts.push(s.table.note);
    }
  });
  return normalize(parts.join(' '));
}

/** Fiche : en-tête (catégorie, titre, résumé) puis ses sections. */
export default function SavoirArticle({ fiche, onNavigate, tenantId, year }) {
  if (!fiche) return null;
  return (
    <article className="sv-article">
      <div className="sv-reader-head">
        <span className={`sv-tag sv-tag-${normalize(fiche.category)}`}>{fiche.category}</span>
        <h2 className="sv-reader-title">{fiche.title}</h2>
        <p className="sv-reader-summary">{fiche.summary}</p>
      </div>
      {fiche.sections.map((s, i) => (
        <Section key={i} s={s} onNavigate={onNavigate} tenantId={tenantId} year={year} />
      ))}
    </article>
  );
}
